import styled from 'styled-components';

export const ShareCreditAppLinkRoot = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.5rem;
    background: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};
    box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.25);
    border-radius: 0.5rem;
`;
